import React from "react";
import { TermsPageMetadata } from "./TermsPage.metadata";
import { TermsPageView } from "./TermsPage.view";

export function TermsPage(props) {
  return (
    <div>
      <TermsPageMetadata />
      <TermsPageView section={props.section} />
    </div>
  );
}
export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" };
}
export async function getStaticProps({ params }) {
  try {
    let section = "";
    if (params.path && params.path.length) {
      section = params.path[0];
    }
    return {
      props: {
        section: section
      },
      revalidate: 60
    };
  } catch (e) {
    throw e;
  }
}
